module.exports = __webpack_public_path__ + "img/celebrity-talk-show.b08264f8.jpg";